var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4044 7.1111C18.4044 4.6565 20.4033 2.66666 22.869 2.66666C25.3348 2.66666 27.3337 4.6565 27.3337 7.1111C27.3337 9.5657 25.3348 11.5555 22.869 11.5555C21.6239 11.5555 20.4987 11.0479 19.6898 10.2313L13.5092 14.4394C13.5664 14.7233 13.5963 15.0166 13.5963 15.3162C13.5963 15.9096 13.479 16.4768 13.2664 16.9951L20.0434 21.4477C20.8125 20.8214 21.7968 20.4444 22.869 20.4444C25.3348 20.4444 27.3337 22.4343 27.3337 24.8889C27.3337 27.3435 25.3348 29.3333 22.869 29.3333C20.4033 29.3333 18.4044 27.3435 18.4044 24.8889C18.4044 24.246 18.542 23.634 18.7893 23.0815L12.0671 18.6649C11.2829 19.3464 10.2558 19.7607 9.13164 19.7607C6.66588 19.7607 4.66699 17.7708 4.66699 15.3162C4.66699 12.8616 6.66588 10.8718 9.13164 10.8718C10.5495 10.8718 11.8117 11.5297 12.6289 12.5536L18.6189 8.47522C18.4796 8.04478 18.4044 7.58612 18.4044 7.1111Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdShare);
export default __webpack_public_path__ + "static/media/pd-share.38016074dffb9d67a0c60b0fc4373d5f.svg";
export { ForwardRef as ReactComponent };